import { useCallback, useEffect, useState } from 'react';

const useMobileChildSheetsState = ({ onRefreshRoles } = {}) => {
  const [mobileSwitchSheetOpen, setMobileSwitchSheetOpen] = useState(false);
  const [mobileActionsSheetOpen, setMobileActionsSheetOpen] = useState(false);

  const openSwitchMenu = useCallback((event) => {
    onRefreshRoles?.();
    event?.preventDefault?.();
    event?.stopPropagation?.();
    setMobileSwitchSheetOpen(true);
  }, [onRefreshRoles]);

  const closeSwitchMenu = useCallback(() => {
    setMobileSwitchSheetOpen(false);
  }, []);

  const openMobileChildSheet = useCallback(() => {
    setMobileActionsSheetOpen(true);
  }, []);

  const closeMobileChildSheet = useCallback(() => {
    setMobileActionsSheetOpen(false);
  }, []);

  const resetMobileChildSheets = useCallback(() => {
    setMobileSwitchSheetOpen(false);
    setMobileActionsSheetOpen(false);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleOpenChildSwitcher = () => {
      setMobileSwitchSheetOpen(true);
    };

    window.addEventListener('captureez:open-mobile-child-switcher', handleOpenChildSwitcher);

    return () => {
      window.removeEventListener('captureez:open-mobile-child-switcher', handleOpenChildSwitcher);
    };
  }, []);

  return {
    closeMobileChildSheet,
    closeSwitchMenu,
    mobileActionsSheetOpen,
    mobileSwitchSheetOpen,
    openMobileChildSheet,
    openSwitchMenu,
    resetMobileChildSheets,
    setMobileSwitchSheetOpen,
  };
};

export default useMobileChildSheetsState;
